<template>
  <div class="space-y-6 lg:space-y-10 max-w-3xl">
    <div v-for="color in colorPalette" :key="color">
      <div class="flex flex-col gap-4 md:flex-row lg:gap-8">
        <div class="w-16 h-10 flex items-center font-semibold text-blue dark:text-white">
          {{ color }}
        </div>
        <div class="flex-1 grid grid-cols-5 gap-5">
          <div
            v-for="shade in Object.keys(colors[color])"
            :key="shade"
          >
            <div
              :style="{ backgroundColor: colors[color][shade] }"
              class="rounded mb-1 h-10 mb-1"
            />
            <div class="sm:flex justify-between text-sm tracking-wide">
              <div class="text-blue dark:text-white font-medium">
                {{ shade }}
              </div>
              <div class="text-gray-500 uppercase">
                {{ colors[color][shade] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import tailwindColors from "@/colors"

const colors = tailwindColors

const colorPalette = [
  "gray",
  "blue",
  "orange",
  "indigo",
  "yellow",
  "green",
  "red",
  "pink",
  "teal",
  "violet",
]
</script>
